var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-wrap w"},[_c('p',[_vm._v(" COPYRIGHT© 福建通文产业服务有限公司 版权所有 备案号："),_c('a',{attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/"}},[_vm._v("闽ICP备2025105166号")])])])])
}]

export { render, staticRenderFns }